import { FC } from 'react';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { TitleRow } from 'components/TitleRow';
import { Link } from 'react-router-dom';
import { OrderItem } from 'ui/OrderItem';
import { CustomerOrderItem } from 'ui/CustomerOrderItem';
import { Nothing } from 'components/Nothing';
import styles from './OrdersList.module.scss';
import { ResponseGetOrderType } from 'redux/Api/ordersApi/type';

interface OrdersListTypes {
  data: ResponseGetOrderType[];
  withCheckbox?: boolean;
  openNav?: boolean;
  selected: string[];
  setSelected: React.Dispatch<React.SetStateAction<string[]>>;
  intersectionComponent: JSX.Element | null;
  hideTitleRow?: boolean;
}

export const OrdersList: FC<OrdersListTypes> = ({
  data,
  withCheckbox = false,
  selected,
  setSelected,
  intersectionComponent,
  hideTitleRow = false,
}) => {
  const role = localStorage.getItem('role') || 'WorkSupport';
  const [parent] = useAutoAnimate({ duration: 300 });

  const toggleSelect = (id: string) => {
    setSelected((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const dataTitle =
    role === 'director'
      ? ['№', 'Дата заказа', 'Услуга', 'Исполнитель', 'Сумма, ₽', 'Статус', 'Дата оплаты']
      : [
          'Период',
          'Заказчик',
          'Исполнитель',
          'Услуга',
          'Стоимость',
          'Вознаграждение оператора',
          'Статус',
        ];

  const status =
    data?.length === 0 || selected.length === 0
      ? 'none'
      : selected.length === data?.length
      ? 'all'
      : 'some';

  const handleToggle = () => {
    if (status === 'all') {
      setSelected([]);
    } else {
      const ids = data.map((item) => item.id);

      setSelected(ids);
    }
  };

  const titleClassName =
    role === 'director'
      ? withCheckbox
        ? 'ordersCustomerCheckbox'
        : 'ordersCustomer'
      : withCheckbox
      ? 'ordersWorksupportCheckbox'
      : 'orders';

  return (
    <div ref={parent} className={styles.root}>
      {!hideTitleRow && (
        <TitleRow
          data={dataTitle}
          title={titleClassName}
          withCheckbox={withCheckbox}
          selected={status}
          toggleSelect={handleToggle}
        />
      )}

      {data?.length ? (
        <div className={styles.window}>
          {data.map((item) => (
            <Link to={`/orders/${item?.id}`} key={item.id} style={{ display: 'flex' }}>
              {role === 'director' ? (
                <CustomerOrderItem
                  order={item}
                  withCheckbox={withCheckbox}
                  selected={selected.includes(item?.id)}
                  toggleSelect={toggleSelect}
                  lastFnsReceipt={
                    item.last_fns_receipt
                      ? item.last_fns_receipt.is_canceled === true
                      : false
                  }
                />
              ) : (
                <OrderItem
                  order={item}
                  withCheckbox={withCheckbox}
                  selected={selected.includes(item?.id)}
                  toggleSelect={toggleSelect}
                />
              )}
            </Link>
          ))}
          {intersectionComponent}
        </div>
      ) : (
        <Nothing style={{ height: '640px' }} title='Ничего не найдено' />
      )}
    </div>
  );
};
